<template>
  <div class="menu-wrap" :class="isOpenMenu ? 'openMenu' : ''">
    <header class="cd-main-header">
      <a class="cd-logo" href="/">
        <span class="cd-logo__icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 169.46 174.81"><defs>
            </defs><g id="Layer_2" data-name="Layer 2"><g><path class="cls-1" d="M48.33,150.59s16.14,24.49,
            47.09,24.21c40.67,0,53.35-49.85,53.35-49.85s20.25-23,20.68-52.75-25.61-61.48-56.38-61.48c0,
            0-12.4-11-39.74-10.72C36.28,0,4.74,22.92.11,59.1c-.64,5.11,1.8,10.6,1.8,16.51,0,0-2.16,24.48,
            11.32,47.51S48.33,150.59,48.33,150.59ZM153.42,44.89s4.86,11.29,4.86,21.3a77.32,77.32,0,0,1-5.89,
            28.52s-2.65-20.28-2.65-23.22S153.42,59,153.42,44.89Zm-118.34,50C35.08,64.89,49.4,51,49.4,51c0,23.63,
            9.11,32.39,9.11,32.39A27.54,27.54,0,0,0,55,97a12.65,12.65,0,0,0,2.63,7.4S35.08,98,35.08,94.87Zm55,
            66.08c-11.33,0-20.56-6.45-20.56-6.45s9.73,1.22,28.21-3,35.67-15.27,35.67-15.27S122,160.95,90.12,
            160.95Zm-15.5-21.54c-13.45,0-20.07,0-25.51-5.3s-12.33-27.65-12.33-27.65,12.27,10.48,49,10.48c35.25,0,
            55.34-28.06,55.34-28.06s.09,2.55.09,18S98.7,139.41,74.62,139.41ZM70.32,97a33.8,33.8,0,0,0,6.92,4,10.27,
            10.27,0,0,1-10.77-1c-5.31-4-3.17-9-3.17-9S67.47,94.77,70.32,97ZM68.07,59.39c0-4.69.18-13.41,
            8.68-13.41s23.84,10.29,23.84,25.46c0,9.49-1.3,16.46-6.67,16.46S68.07,74.66,68.07,59.39ZM147.36,
            39c.33,4.53-1.68,17.53-1.68,17.53s-2.91-10-5-15.13-8.45-14.07-8.45-14.07C135.44,27.29,147.36,
            32.32,147.36,39ZM131.3,50s7.51,18.91,7.51,24.23-7,10.63-8.43,10.63c-.66,0,2.49-6.41,2.85-13.79C133.62,
            62.58,131.3,50,131.3,50ZM109.6,85.92a183.19,183.19,0,0,0,1.63-19c0-37.21-41.14-33.09-41.14-33.09A70,
            70,0,0,1,87.7,31.29c23.08,0,34,15.1,34,30.51C121.65,74.85,109.6,85.92,109.6,85.92ZM12.2,67.24c0-9.24,
            9.44-31.59,9.44-31.59S43.32,16.14,78.56,16.14s37,10.36,37,10.36a62.77,62.77,0,0,0-30.55-8c-40.75,
            0-60.27,46.34-60.27,69.81C24.7,88.31,12.2,83.37,12.2,67.24Zm1.68,26.9,11.45,8.6s2,7.91,4.08,13.86,
            5.38,13,5.38,13-5.07-2.24-12.46-13.64A54.44,54.44,0,0,1,13.88,94.13Z"></path></g></g></svg>
          </span>
        <span class="cd-logo__main">
          <span class="cd-logo__logo">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 355.18 52.89"><defs>
          </defs><g id="Layer_2" data-name="Layer 2"><g><path class="cls-1" d="M27.26,7.73C22.06,3.86,16.37,3.16,9.83,
          3.16H0V50H9.69c6.53,0,11.66-.63,17.14-4.5,6.18-4.35,9.41-11.1,9.41-18.9A23.19,23.19,0,0,0,27.26,7.73ZM22.69,
          40c-4.07,3-8.92,3.3-12.43,3.3H7.16V9.91h3.09c3.44,0,8.43.28,12.5,3.23a16.69,16.69,0,0,1,6.32,13.49A16.51,
          16.51,0,0,1,22.69,40Z"></path><path class="cls-1" d="M72.64,2.32c-14,0-24.38,10.54-24.38,24.31s10.33,24.3,
          24.38,24.3S97,40.39,97,26.62,86.69,2.32,72.64,2.32Zm0,42c-10,0-17.21-7.31-17.21-17.7s7.16-17.7,17.21-17.7,
          17.21,7.31,17.21,17.7S82.68,44.32,72.64,44.32Z"></path>
            <polygon class="cls-1"
                     points="111.28 0 111.28 50.02 118.44 50.02 118.44 17.28 152.44 52.89 152.44 3.16
                     145.28 3.16 145.28 35.62 111.28 0"></polygon>
            <path class="cls-1" d="M217,17.07a13.56,13.56,0,0,
            0-5.83-11.38c-3.37-2.25-7.38-2.53-10.26-2.53H190.59V50h7.16V31H201c3.44,0,7.73-.49,11.45-3.65A13.12,
            13.12,0,0,0,217,17.07Zm-16,7.31h-3.23V9.76h3.16c8.15,0,9.2,4.64,9.2,7.24C210.12,21.35,207.16,24.38,
            201,24.38Z"></path><rect class="cls-1" x="229.58" y="3.16" width="7.16" height="46.85"></rect>
            <path class="cls-1" d="M299.75,26.62c0-13.77-10.33-24.31-24.38-24.31S251,12.85,251,26.62s10.33,24.3,
            24.37,24.3S299.75,40.39,299.75,26.62Zm-41.58,0c0-10.4,7.16-17.7,17.21-17.7s17.21,7.31,17.21,17.7-7.17,
            17.7-17.21,17.7S258.17,37,258.17,26.62Z"></path>
            <polygon class="cls-1" points="348.01 3.16 348.01 35.62 314.02 0 314.02 50.02 321.18 50.02 321.18
            17.28 355.18 52.89 355.18 3.16 348.01 3.16"></polygon></g></g></svg>
          </span>
          <span class="cd-logo__slogan">
          <svg xmlns="http://www.w3.org/2000/svg"
               viewBox="0 0 254.95 24.52"><defs></defs>
            <g id="Layer_2" data-name="Layer 2"><g><path class="cls-1" d="M2.1,1.06a4.71,4.71,0,0,0-1,
            3.33V8.08H0v2.27H1.06v8.36H3.54V10.36H6.21V8.08H3.54v-4a1.75,1.75,0,0,1,.4-1.26A1.44,1.44,0,0,
            1,5,2.4a2.14,2.14,0,0,1,1.19.38V.33A3.94,3.94,0,0,0,4.62,0,3.33,3.33,0,0,0,2.1,1.06Z"></path>
              <path class="cls-1" d="M11.14,8.16a4.27,4.27,0,0,0-1,.88v-1H7.63V18.72h2.48V13.21a3.42,3.42,
              0,0,1,.68-2.45,1.93,1.93,0,0,1,1.54-.58,2.23,2.23,0,0,1,1.26.38l1-2.25a3.67,3.67,0,0,
              0-1.94-.51A2.85,2.85,0,0,0,11.14,8.16Z"></path><path class="cls-1" d="M19.93,7.81a4.84,4.84,
              0,0,0-3.56,1.44,6.23,6.23,0,0,0-1.69,4.37,5.7,5.7,0,0,0,1.57,4.07A4.72,4.72,0,0,0,19.83,19,5.87,
              5.87,0,0,0,23,18.24a5.59,5.59,0,0,0,1.79-1.95l-2.07-1.16a3.85,3.85,0,0,1-1,1.16,2.61,2.61,0,0,1-1.69.53,
              2.53,2.53,0,0,1-1.89-.68A3.51,3.51,0,0,1,17.2,14h7.63v-.3a6.39,6.39,0,0,0-1.49-4.5A4.58,4.58,0,0,0,19.93,
              7.81ZM17.38,12a2.79,2.79,0,0,1,.76-1.37,2.58,2.58,0,0,1,3.41-.07A2.57,2.57,0,0,1,22.31,12Z"></path>
              <path class="cls-1" d="M32,12.48l-1.26-.63c-.53-.28-.68-.33-.83-.43a.68.68,0,0,1-.35-.61.8.8,0,0,
              1,.23-.55,1,1,0,0,1,.76-.28,1.78,1.78,0,0,1,1.52.91L33.9,9.67a3.64,3.64,0,0,0-1.21-1.31,3.33,3.33,0,0,
              0-2-.56,3.43,3.43,0,0,0-2.6,1,3.32,3.32,0,0,0-.88,2.27A2.32,2.32,0,0,0,28,12.88a5.27,5.27,0,0,0,
              1.46.91l.91.43a3.28,3.28,0,0,1,1.06.66,1.15,1.15,0,0,1,.33.81,1.26,1.26,0,0,1-.35.83,1.49,1.49,0,0,
              1-1,.35,1.51,1.51,0,0,1-1.09-.4,2.78,2.78,0,0,1-.58-1l-2,1a4.15,4.15,0,0,0,1.36,1.94,3.66,3.66,0,0,0,
              2.3.68,3.8,3.8,0,0,0,3-1.19,3.53,3.53,0,0,0,.93-2.42,2.62,2.62,0,0,0-.78-2A5.07,5.07,
              0,0,0,32,12.48Z"></path>
              <path class="cls-1" d="M41.84,7.81A3.82,3.82,0,0,0,39,9V.3H36.51V18.72H39V13.59a4.77,4.77,0,0,
              1,.51-2.68A2.2,2.2,0,0,1,41.31,10a1.87,1.87,0,0,1,1.39.56,2.56,2.56,0,0,1,.48,1.84v6.29h2.48V12.2a5.23,
              5.23,0,0,0-.68-3A3.61,3.61,0,0,0,41.84,7.81Z"></path><path class="cls-1" d="M59.07,0a4.22,4.22,0,
              0,0-3.69,1.64,4.75,4.75,0,0,0-.66,2.9V8.08h-.86v2.27h.86v8.36H57.2V10.36h2.68V8.08H57.2V4.82a3.08,
              3.08,0,0,1,.3-1.64,1.64,1.64,0,0,1,1.57-.81,1.71,1.71,0,0,1,1.57.81,3.46,3.46,0,0,1,.3,
              1.64V18.72h2.48V4.55a4.89,4.89,0,0,0-.66-2.9C62.38,1.06,61.52,0,59.07,0Z"></path>
              <path class="cls-1" d="M71.68,7.81A5.49,5.49,0,0,0,66,13.41a5.68,5.68,0,0,0,11.37,
              0A5.49,5.49,0,0,0,71.68,7.81Zm0,9a3.06,3.06,0,0,1-3.16-3.39,3.17,3.17,0,1,1,6.31,0A3.06,
              3.06,0,0,1,71.68,16.82Z"></path>
              <polygon class="cls-1" points="90.02 14.17 87.04 7.17 84.06 14.17 81.3 8.08 78.53 8.08 84.06 19.47
              87.04 12.68 90.02 19.47 95.55 8.08 92.77 8.08 90.02 14.17"></polygon>
              <path class="cls-1" d="M101.69,7.81a4.84,4.84,0,0,0-3.56,1.44,6.23,6.23,0,0,0-1.69,
              4.37A5.7,5.7,0,0,0,98,17.68,4.72,4.72,0,0,0,101.59,19a5.87,5.87,0,0,0,3.13-.81,5.59,
              5.59,0,0,0,1.79-1.95l-2.07-1.16a3.85,3.85,0,0,1-1,1.16,2.61,2.61,0,0,1-1.69.53,2.53,
              2.53,0,0,1-1.89-.68A3.51,3.51,0,0,1,99,14h7.63v-.3a6.39,6.39,0,0,0-1.49-4.5A4.58,4.58,0,
              0,0,101.69,7.81ZM99.14,12a2.79,2.79,0,0,1,.76-1.37,2.58,2.58,0,0,1,3.41-.07,2.57,2.57,
              0,0,1,.76,1.44Z"></path><path class="cls-1" d="M112.68,8.16a4.27,4.27,0,0,
              0-1,.88v-1h-2.48V18.72h2.48V13.21a3.42,3.42,0,0,1,.68-2.45,1.93,1.93,0,0,1,1.54-.58,2.23,2.23,0,0,
              1,1.26.38l1-2.25a3.67,3.67,0,0,0-1.94-.51A2.85,2.85,0,0,0,112.68,8.16Z"></path>
              <path class="cls-1" d="M121.65,12.48l-1.26-.63c-.53-.28-.68-.33-.83-.43a.68.68,0,0,
              1-.35-.61.8.8,0,0,1,.23-.55,1,1,0,0,1,.76-.28,1.78,1.78,0,0,1,1.52.91l1.84-1.21a3.64,3.64,
              0,0,0-1.21-1.31,3.33,3.33,0,0,0-2-.56,3.43,3.43,0,0,0-2.6,1,3.32,3.32,0,0,0-.88,2.27,2.32,2.32,
              0,0,0,.76,1.79,5.27,5.27,0,0,0,1.46.91l.91.43a3.28,3.28,0,0,1,1.06.66,1.15,1.15,0,0,1,.33.81,
              1.26,1.26,0,0,1-.35.83,1.49,1.49,0,0,1-1,.35,1.51,1.51,0,0,1-1.09-.4,2.78,2.78,0,0,1-.58-1l-2,
              1a4.15,4.15,0,0,0,1.36,1.94A3.66,3.66,0,0,0,120,19a3.8,3.8,0,0,0,3-1.19,3.53,3.53,0,0,0,.93-2.42,
              2.62,2.62,0,0,0-.78-2A5.07,5.07,0,0,0,121.65,12.48Z"></path>
              <path class="cls-1" d="M145.68,12.53,144,10.81,142.12,13l-3-3.64a10.2,10.2,0,0,0,
              2.1-1.95A3.54,3.54,0,0,0,142,5.2a4,4,0,0,0-8,.25,5.23,5.23,0,0,0,1.67,3.49c-.15.1-.88.61-1.34.93a5,5,0,
              0,0-2.42,4.34A4.69,4.69,0,0,0,136.89,19a5.89,5.89,0,0,0,3.69-1.16A9.86,9.86,0,0,0,142,16.64l1.67,
              2.07h3.13l-3.11-3.89Zm-7.75-8.84a1.5,1.5,0,0,1,1.67,1.52,2.14,2.14,0,0,1-1,1.67l-.93.68-.76-.91a2.41,
              2.41,0,0,1-.58-1.46A1.45,1.45,0,0,1,137.92,3.69Zm1,12.53a3.3,3.3,0,0,1-1.89.65,2.53,2.53,0,0,1-2.63-2.55,
              3.12,3.12,0,0,1,.91-2.15,7.84,7.84,0,0,1,1.84-1.39l3.33,4A15.54,15.54,0,0,1,138.88,16.22Z"></path>
              <path class="cls-1" d="M158.84,12.48l-1.26-.63c-.53-.28-.68-.33-.83-.43a.68.68,0,0,1-.35-.61.8.8,0,0,
              1,.23-.55,1,1,0,0,1,.76-.28,1.78,1.78,0,0,1,1.52.91l1.84-1.21a3.64,3.64,0,0,0-1.21-1.31,3.33,3.33,0,0,
              0-2-.56,3.43,3.43,0,0,0-2.6,1,3.32,3.32,0,0,0-.88,2.27,2.32,2.32,0,0,0,.76,1.79,5.27,5.27,0,0,0,
              1.46.91l.91.43a3.28,3.28,0,0,1,1.06.66,1.15,1.15,0,0,1,.33.81,1.26,1.26,0,0,1-.35.83,1.49,1.49,0,0,
              1-1,.35,1.51,1.51,0,0,1-1.09-.4,2.78,2.78,0,0,1-.58-1l-2,1a4.15,4.15,0,0,0,1.36,1.94,3.66,3.66,0,0,0,
              2.3.68,3.8,3.8,0,0,0,3-1.19,3.53,3.53,0,0,0,.93-2.42,2.62,2.62,0,0,0-.78-2A5.07,5.07,0,0,0,
              158.84,12.48Z"></path><path class="cls-1" d="M174.35,7.81a3.77,3.77,0,0,0-3.16,1.57,3.12,3.12,0,0,
              0-2.75-1.57,3.28,3.28,0,0,0-2.63,1.26v-1h-2.48V18.72h2.48V13.23a4.32,4.32,0,0,1,.48-2.42,1.83,1.83,
              0,0,1,1.46-.78,1.4,1.4,0,0,1,1.41.94,4.92,4.92,0,0,1,.23,1.89v5.86h2.48V13.23a4.32,4.32,0,0,1,.48-2.42,
              1.83,1.83,0,0,1,1.46-.78,1.4,1.4,0,0,1,1.41.94,4.92,4.92,0,0,1,.23,1.89v5.86h2.48V12.15a5.24,5.24,0,0,
              0-.56-2.68A3.41,3.41,0,0,0,174.35,7.81Z"></path><path class="cls-1" d="M188.86,9.32a3.88,3.88,0,0,
              0-3.16-1.52c-2.8,0-5.18,2.12-5.18,5.58,0,2.93,1.87,5.66,5.15,5.66a4.09,4.09,0,0,0,
              3.18-1.44v1.11h2.48V8.08h-2.48ZM186,16.82a3.1,3.1,0,0,1-3-3.39c0-1.89,1.16-3.41,3-3.41,1.57,0,3,1.11,
              3,3.43A3,3,0,0,1,186,16.82Z"></path>
              <path class="cls-1" d="M198,8.16a4.25,4.25,0,0,0-1,.88v-1h-2.48V18.72h2.48V13.21a3.43,3.43,0,0,
              1,.68-2.45,1.93,1.93,0,0,1,1.54-.58,2.23,2.23,0,0,1,1.26.38l1-2.25a3.68,3.68,0,0,0-1.95-.51A2.85,
              2.85,0,0,0,198,8.16Z"></path><polygon class="cls-1" points="205.91 4.19 203.44 4.19 203.44 8.08 202.4
              8.08 202.4 10.36 203.44 10.36 203.44 18.72 205.91 18.72 205.91 10.36 207.81 10.36 207.81 8.08
              205.91 8.08 205.91 4.19"></polygon><path class="cls-1" d="M223.14,9.25A4,4,0,0,0,220,7.81a4.83,4.83,
              0,0,0-3.61,1.46,5.65,5.65,0,0,0-1.57,4.12,6,6,0,0,0,1.59,4.22A4.51,4.51,0,0,0,219.91,19a3.85,3.85,
              0,0,0,3.23-1.52v1.39a3.5,3.5,0,0,1-.81,2.68,2.66,2.66,0,0,1-1.94.71,2.53,2.53,0,0,1-1.92-.73,3.52,
              3.52,0,0,1-.78-1.67h-2.4a6,6,0,0,0,1.57,3.31,4.7,4.7,0,0,0,3.49,1.31,5.41,5.41,0,0,0,
              3.54-1.14c1.46-1.24,1.74-3,1.74-5.53V8.08h-2.48ZM222.36,16a2.69,2.69,0,0,1-2.07.86,2.9,2.9,0,
              0,1-1.9-.71,3.65,3.65,0,0,1-1.06-2.68,3.69,3.69,0,0,1,1.09-2.7,2.56,2.56,0,0,1,
              1.87-.71,2.63,2.63,0,0,1,2,.76,3.55,3.55,0,0,1,1,2.68A3.53,3.53,0,0,1,222.36,16Z"></path>
              <rect class="cls-1" x="228.75" y="8.08" width="2.48" height="10.63"></rect>
              <path class="cls-1" d="M235.65,1.06a4.71,4.71,0,0,0-1,
              3.33V8.08h-1.06v2.27h1.06v8.36h2.48V10.36h2.68V8.08h-2.68v-4a1.76,1.76,0,0,1,.4-1.26,1.44,
              1.44,0,0,1,1.09-.4,2.14,2.14,0,0,1,1.19.38V.33a3.94,3.94,0,0,0-1.59-.3A3.33,3.33,0,0,
              0,235.65,1.06Z"></path>
              <polygon class="cls-1" points="244.52 4.19 242.04 4.19 242.04 8.08 241.01 8.08 241.01 10.36 242.04
              10.36 242.04 18.72 244.52 18.72 244.52 10.36 246.41 10.36 246.41 8.08 244.52 8.08 244.52 4.19"></polygon>
              <path class="cls-1" d="M252.68,12.48l-1.26-.63c-.53-.28-.68-.33-.83-.43a.68.68,0,0,
              1-.35-.61.8.8,0,0,1,.23-.55,1,1,0,0,1,.76-.28,1.78,1.78,0,0,1,1.52.91l1.84-1.21a3.64,3.64,0,
              0,0-1.21-1.31,3.33,3.33,0,0,0-2-.56,3.43,3.43,0,0,0-2.6,1,3.32,3.32,0,0,0-.88,2.27,2.32,2.32,0,0,
              0,.76,1.79,5.25,5.25,0,0,0,1.46.91l.91.43a3.28,3.28,0,0,1,1.06.66,1.15,1.15,0,0,1,.33.81,1.26,
              1.26,0,0,1-.35.83,1.49,1.49,0,0,1-1,.35,1.51,1.51,0,0,1-1.09-.4,2.78,2.78,0,0,1-.58-1l-2,1a4.15,
              4.15,0,0,0,1.36,1.94A3.66,3.66,0,0,0,251,19a3.8,3.8,0,0,0,3-1.19,3.53,3.53,0,0,0,.93-2.42,2.63,
              2.63,0,0,0-.78-2A5.07,5.07,0,0,0,252.68,12.48Z"></path></g></g></svg>
          </span>
        </span>
      </a>
      <nav class="cd-nav">
        <ul class="cd-primary-nav is-fixed">
          <li><a class="top-nav__unit top-nav__menu" href="/bouquets/">{{ $t('Bouquets') }}</a></li>
          <li><a class="top-nav__unit top-nav__menu" href="/about-company-1/">{{ $t('AboutUs') }}</a></li>
          <li><a class="top-nav__unit top-nav__menu" href="/payment/">{{ $t('Payment') }}</a></li>
          <li><a class="top-nav__unit top-nav__menu" href="/delivery/">{{ $t('Delivery') }}</a></li>
          <li><a class="top-nav__unit top-nav__menu" href="/shops/">{{ $t('Shop') }}</a></li>
          <li><a class="top-nav__unit top-nav__menu" href="/contacts/">{{ $t('Contacts') }}</a></li>
          <li><div class="top-nav__unit top-nav__menu space"></div></li>
          <li v-if="!isLoggedIn">
            <router-link class="top-nav__link" :to="{name: 'orders'}">
              <div class="top-nav__unit"><img class="top-nav__unit__user" :src="logoUser" alt="logo user"></div>
            </router-link>
          </li>
          <li v-if="isLoggedIn">
            <div class="top-nav__link" @click="logout">
              <div class="top-nav__unit">{{ $t('Logout') }}</div>
            </div>
          </li>
          <li>
            <dashboard-topbar-cart/>
          </li>
          <li>
            <div class="hamburger" @click="openCloseMenu()" :class="isOpenMenu ? 'openMenu' : ''">
              <div class="line"></div>
              <div class="line"></div>
              <div class="line"></div>
            </div>
          </li>
          <li><div class="top-nav__unit space-small top-nav__menu"></div></li>
        </ul>
      </nav>
      <nav class="cd-mobile-nav" :class="isOpenMenu ? 'openMenu' : ''">
        <ul class="cd-primary-nav is-fixed">
          <li><a class="top-nav__unit" href="/bouquets/">{{ $t('Bouquets') }}</a></li>
          <li><a class="top-nav__unit" href="/about-company-1/">{{ $t('AboutUs') }}</a></li>
          <li><a class="top-nav__unit" href="/payment/">{{ $t('Payment') }}</a></li>
          <li><a class="top-nav__unit" href="/delivery/">{{ $t('Delivery') }}</a></li>
          <li><a class="top-nav__unit" href="/shops/">{{ $t('Shop') }}</a></li>
          <li><a class="top-nav__unit" href="/contacts/">{{ $t('Contacts') }}</a></li>
        </ul>
      </nav>
    </header>
  </div>
</template>

 <script>
 import {mapGetters} from "vuex";
 import {getterTypes, actionTypes} from "@/store/modules/auth";
 import DashboardTopbarCart from "@/components/Cart.vue"

 export default {
   name: 'DashboardTopbar',
   components: {
     DashboardTopbarCart,
   },
   data(){
     return {
       logoUser: require('@/assets/svg/person-circle.svg'),
       logoCart: require('@/assets/svg/cart3.svg'),
       isOpenMenu: false,
     }
   },
    computed: {
      ...mapGetters({
        isLoading: getterTypes.isLoading,
        isLoggedIn: getterTypes.isLoggedIn,
        currentUser: getterTypes.currentUser,
      }),
    },
   methods: {
     logout(){
       this.$store.dispatch(actionTypes.logout)
     },
     openCloseMenu(){
       if (this.isOpenMenu === false){
         this.isOpenMenu = true
       } else {
         this.isOpenMenu = false
       }
     }
   }
 }
 </script>

<style lang="scss" scoped>
  @import "@/scss/variables.scss";

  .cls-1{
    fill:#384967;
  }
  .menu-wrap.openMenu{
    height: 410px !important;
    @media only screen and (min-width: $max-width-tablet) {
      height: 76px !important;
    }
  }
  .menu-wrap{
    top: 0;
    width: 100%;
    height: 76px;
    position: fixed;
    left: 0;
    z-index: 9999;
    background-color: $bg-topbar;
    opacity: 95%;
    box-shadow: 0 3px 3px 0 rgba(0,0,0,.1);
    transition: top .05s;
    .cd-main-header{
      display: block;
      max-width: 1360px;
      margin: 0 auto;
      height: 76px;
      .cd-logo{
        top: 16px;
        left: 15px;
        display: inline-flex;
        justify-content: flex-start;
        position: relative;
        &__main {
          display: inline-flex;
          flex-direction: column;
          align-items: center;
          @media only screen and (max-width: $max-width-laptop) {
            display: none;
          }
        }
        &__logo{
          color: $fd;
          width: 201px;
          display: inline-block;
        }
        &__slogan{
          color: $fd;
          width: 166px;
          display: inline-block;
        }
        .cd-logo__icon{
          flex-direction: column;
          align-items: center;
          color: $fd;
          width: 30px;
          display: none;
          @media only screen and (max-width: $max-width-laptop) {
            display: inline-block;
            padding-top: 10px;
          }
        }
      }
      .cd-mobile-nav.openMenu{
        display: inline;
      }
      .cd-nav{
        top: 0;
        float: right;
        .hamburger{
          display: none;
          cursor: pointer;
          padding-top: 22px;
          @media only screen and (max-width: $max-width-tablet) {
            display: block;
          }
          .line{
            width: 30px;
            height: 3px;
            background: $fd;
            margin: 6px 0;
          }
        }
      }
      .cd-primary-nav{
        display: inline;
        padding: 0 25% 0 0;
         @media only screen and (max-width: $max-width-tablet) {
           display: flex;
         }
      }
      .cd-primary-nav>li {
        margin-left: 15px;
        float: left;
        list-style: none;
        @media only screen and (max-width: $max-width-tablet) {
          margin-left: 0;
        }
      }
      .cd-primary-nav>li>a, .cd-primary-nav>li>div {
        font-size: 16px;
        line-height: 80px;
        height: 80px;
        text-transform: uppercase;
        text-decoration: none;
        position: relative;
        display: inline-block;
        padding: 0 10px;
        color: #2e3233;
        overflow: visible;
        border-bottom: none;
        -webkit-transition: color .3s,box-shadow .3s;
        -moz-transition: color .3s,box-shadow .3s;
        transition: color .3s,box-shadow .3s;
      }
      .cd-primary-nav>li>.space{
        width: 100px;
      }
      .cd-primary-nav>li>.space-small{
        width: 20px;
      }
      .top-nav{
        &__link{
          cursor: pointer;
        }
        &__unit{
          &__user{
            height: 22px;
            width: 22px;
            opacity: 80%;
          }
          &__cart{
            height: 22px;
            width: 22px;
            opacity: 80%;
          }
        }
        &__menu{
          @media only screen and (max-width: $max-width-tablet) {
            display: none !important;
          }
        }
      }
      .cd-mobile-nav{
        display: none;
        padding: 0 0 0 35%;
        position: absolute;
        top: 80px;
        @media only screen and (max-width: 420px) {
          padding: 0 0 0 25%;
        }
        @media only screen and (max-width: 364px) {
          padding: 0 0 0 30%;
        }
        @media only screen and (min-width: $max-width-tablet) {
            display: none !important;
        }
        .cd-primary-nav{
          display: inline-grid;
        }
        .cd-primary-nav>li>a, .cd-primary-nav>li>div {
          line-height: 50px;
          height: 50px;
        }
      }
      .cd-mobile-nav ul{
        display: block;
        width: fit-content;
        margin: 0 auto 0 auto;
      }
      .cd-mobile-nav>li {
        margin-left: 15px;
        list-style: none;
      }
    }
  }
</style>